import { render } from "./SplitTradeModal.vue?vue&type=template&id=b4b0185e&scoped=true"
import script from "./SplitTradeModal.vue?vue&type=script&lang=js"
export * from "./SplitTradeModal.vue?vue&type=script&lang=js"

import "./SplitTradeModal.vue?vue&type=style&index=0&id=b4b0185e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b0185e"]])

export default __exports__